import { SvgBox, SvgBoxProps } from "@govlaunch/web";
import React from "react";

export default function SavedProductsIcon(props: SvgBoxProps) {
  return (
    <SvgBox width="24px" height="24px" viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx={12} cy={12} r={10.75} fill="#fff" stroke="#3F4A5A" strokeWidth={2.5} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.274 7.382c-.476 0-.836.326-.836.694v9.165L12 14.224l3.562 3.017V8.076c0-.368-.36-.694-.836-.694H9.274zm-1.89.694c0-.905.864-1.614 1.89-1.614h5.452c1.026 0 1.89.71 1.89 1.614v9.694c0 .396-.374.692-.8.692h0a.87.87 0 01-.557-.196l-.002-.002L12 15.506l-3.255 2.757h-.001a.891.891 0 01-.86.147c-.295-.103-.5-.352-.5-.64V8.076z"
        fill="#3F4A5A"
        stroke="#3F4A5A"
        strokeWidth={0.8}
      />
    </SvgBox>
  );
}
